import { Box, Typography, useTheme } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useTenantTranslation } from "hooks/formatters";

interface NoMixSummaryForGroupErrorMessageProps {
  chemistryGroupId: number;
  chemistryGroupName: string;
}

const NoMixSummaryForGroupErrorMessage = ({
  chemistryGroupId,
  chemistryGroupName,
}: NoMixSummaryForGroupErrorMessageProps) => {
  const { t } = useTenantTranslation();
  const theme = useTheme();

  console.error(
    `MixDetailsView: No mix summary found for chemistry group ID ${chemistryGroupId}`
  );

  return (
    <Box
      sx={{
        borderRadius: 1,
        backgroundColor: "grey.50",
        p: 4,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <ErrorOutlineIcon
        sx={{
          fontSize: 48,
          color: theme.palette.text.secondary,
        }}
      />
      <Typography
        variant="h6"
        sx={{
          color: theme.palette.text.primary,
          fontWeight: theme.typography.fontWeightMedium,
        }}
        gutterBottom
      >
        {t("mixSummaryNotFound")}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.secondary,
          maxWidth: 400,
        }}
      >
        {t("mixSummaryNotFoundDescription", {
          chemistryGroup: chemistryGroupName,
        })}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: theme.palette.text.secondary,
          mt: 1,
        }}
      >
        {t("tryAgainOrContactUs")}
      </Typography>
    </Box>
  );
};

export default NoMixSummaryForGroupErrorMessage;
